import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGroupDisplacementOrigin = () => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const groupDisplacementOrigin = ({ branchesGuids, originGuid }, onUpdate) => {
    setLoading(true);

    axiosClient
      .put(`Product/Branch/ChangeRangeOrigin`, {
        guid: branchesGuids,
        originGuid,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res?.data?.message, { variant: 'success' });
          onUpdate();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [groupDisplacementOrigin, loading];
};

export default useGroupDisplacementOrigin;
